$shm_hitalama_text_link $mol_link_iconed
	favicon true
